<div class="dialog-container">
    <h2 mat-dialog-title>
        <mat-icon>edit</mat-icon>
        Herkunftsbetrieb bearbeiten
    </h2>

    <mat-dialog-content>
        <form [formGroup]="herkunftForm" class="herkunft-form" (ngSubmit)="$event.preventDefault()">
            <!-- Anzeige des aktuell ausgewählten Betriebs -->
            <div *ngIf="selectedBetrieb" class="current-betrieb">
                <h4>Aktueller Herkunftsbetrieb:</h4>
                <kiene-betriebskontakt-card
                    [kontakt]="selectedBetrieb"
                    [config]="{
                        showActions: true,
                        showMenu: false,
                        showFavorit: false,
                        showBadge: true,
                        compact: true,
                        selectedMode: true
                    }"
                    (entfernen)="removeHandler()"
                >
                </kiene-betriebskontakt-card>
            </div>

            <!-- Betriebskontakte-Auswahl -->
            <div class="betrieb-auswahl">
                <h4>Herkunftsbetrieb auswählen:</h4>

                <kiene-betriebskontakt-auswahl
                    [config]="{
                        showLandwirte: true,
                        showHaendler: true,
                        showSchlachthoefe: true,
                        showAll: true,
                        multiSelect: false,
                        compact: true,
                        title: 'Herkunftsbetrieb auswählen',
                        placeholder: 'Betrieb suchen...',
                        allowCreateNew: true,
                        keepOpenOnSelect: false
                    }"
                    [selectedKontakte]="selectedBetrieb ? [selectedBetrieb] : []"
                    (kontaktSelected)="onBetriebskontaktSelected($event)"
                    (kontakteSelected)="onBetriebskontakteSelected($event)"
                >
                </kiene-betriebskontakt-auswahl>
            </div>

            <p *ngIf="canEditPlaceholderHerkunft" class="placeholder-hint">
                Dieser Betrieb wurde nur mit VVVO angelegt. Name und Adresse können hier korrigiert werden.
            </p>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Betrieb</mat-label>
                    <input matInput formControlName="herkunft_betrieb" placeholder="Betriebsname eingeben" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Straße</mat-label>
                    <input matInput formControlName="herkunft_strasse" placeholder="Straße eingeben" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>PLZ</mat-label>
                    <input matInput formControlName="herkunft_plz" placeholder="PLZ eingeben" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Ort</mat-label>
                    <input matInput formControlName="herkunft_ort" placeholder="Ort eingeben" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Ortsteil</mat-label>
                    <input matInput formControlName="herkunft_ortsteil" placeholder="Ortsteil eingeben" />
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="cancel()" [disabled]="isLoading">Abbrechen</button>
        <button type="button" mat-raised-button color="primary" (click)="save()" [disabled]="isLoading">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">Speichern</span>
        </button>
    </mat-dialog-actions>
</div>
